import React, { FC } from 'react'
import Button from '@mui/material/Button'
import { Popover } from '@mui/material'
import ClosePopoversProvider from './ClosePopoversProvider'
import { ButtonTypeMap } from '@mui/material/Button/Button'
import { PopoverProps } from '@mui/material/Popover/Popover'

export interface AppPopoverProps {
	children?: React.ReactNode
	openButtonLabel?: string
	renderOpenButton?: (
		onClick: React.MouseEventHandler<HTMLButtonElement>,
		open?: boolean
	) => React.ReactNode
	popoverProps?: Omit<PopoverProps, 'id' | 'open' | 'anchorEl' | 'onClose'>
	openButtonProps?: Omit<ButtonTypeMap['props'], 'onClick'>
}

const AppPopover: FC<AppPopoverProps> = ({
	children,
	openButtonLabel,
	renderOpenButton,
	popoverProps = {},
	openButtonProps = {},
}: AppPopoverProps) => {
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
		null
	)

	const { anchorOrigin, transformOrigin, ...restPopoverProps } = popoverProps

	const handleClick: React.MouseEventHandler<HTMLButtonElement> = event => {
		event.stopPropagation()

		setAnchorEl(event.currentTarget)
	}

	const handleClose = (event: MouseEvent): void => {
		event?.stopPropagation()

		setAnchorEl(null)
	}

	const open = Boolean(anchorEl)
	const id = open ? 'more-popover' : undefined

	return (
		<>
			{!renderOpenButton && (
				<Button
					aria-describedby={id}
					onClick={handleClick}
					sx={{
						lineHeight: 'normal',
					}}
					{...openButtonProps}
				>
					{openButtonLabel}
				</Button>
			)}

			{renderOpenButton && renderOpenButton(handleClick, open)}

			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
					...anchorOrigin,
				}}
				transformOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
					...transformOrigin,
				}}
				{...restPopoverProps}
			>
				<ClosePopoversProvider onClose={handleClose}>
					{children}
				</ClosePopoversProvider>
			</Popover>
		</>
	)
}

export default AppPopover
